import "./style.css";
import { AiOutlineDelete, AiOutlineFileText } from "react-icons/ai";
import {
    Avatar,
    Button,
    Card,
    Col,
    Collapse,
    Image,
    Input,
    List,
    Modal,
    Row,
    Skeleton,
    Space,
    Spin,
    Typography,
    message,
    theme,
} from "antd";
import { DownOutlined, RightOutlined, UpOutlined } from "@ant-design/icons";
import {
    FaBookOpen,
    FaFileAudio,
    FaImage,
    FaRegFilePowerpoint,
    FaVideo,
    FaLink,
} from "react-icons/fa";
import {
    FaComments,
    FaFilePowerpoint,
    FaPaperclip,
    FaReadme,
} from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { api, api_url } from "../../services/api";
import {
    getProfileLocal,
    setCoursesLocal,
    setProfileLocal,
} from "../../utils/common";

import { AiOutlineEdit } from "react-icons/ai";
import AppLayout from "../../components/Layout";
import ReactPlayer from "react-player";
import Title from "antd/es/typography/Title";
import { UserContext } from "../../contexts/AuthContext";

const { Panel } = Collapse;
const { TextArea } = Input;
const { useToken } = theme;
const modules = [
    {
        title: "Módulo 1: Introdução ao conceito de Hamada",
        description: "Descrição do módulo 1",
    },
    {
        title: "Módulo 2: Fórmula de Hamada e sua importância",
        description: "Descrição do módulo 2",
    },
    {
        title: "Módulo 3: Cálculo da alavancagem financeira",
        description: "Descrição do módulo 3",
    },
];
export default function Lesson({ videoId }) {
    const { profile } = React.useContext(UserContext);
    const navigate = useNavigate();
    const { course_hash, module_hash, lesson_hash, content_hash } = useParams();
    const token = useToken();

    const [showModal, setShowModal] = useState(false);
    const [textareaValue, setTextareaValue] = useState("");
    const [showDescription, setShowDescription] = useState(true);
    const [loading, setLoading] = useState(false);

    const [lesson, setLesson] = useState({});
    const [course, setCourse] = useState({});

    const [openKey, setOpenKey] = useState(null);
    const [openLessonKey, setOpenLessonKey] = useState([lesson_hash]);

    const handleAccordion = (key) => {
        setOpenKey(openKey === key ? null : key);
    };

    const handleLessonKey = (key) => {
        setOpenLessonKey(openLessonKey === key ? null : key);
    };

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const handleTextareaChange = (e) => setTextareaValue(e.target.value);
    const handleShowDescription = () => setShowDescription(!showDescription);

    let componentMounted = true;

    const getLesson = async () => {
        setLoading(true);
        await api
            .get(
                `/panel/student-courses/${course_hash}/modules/${module_hash}/lessons/${lesson_hash}`
            )
            .then((res) => {
                console.log(res.data.data);
                setLesson(res.data.data);
                
                // Definir o additionalContent se existir content_hash
                if (content_hash && res.data.data.additional_contents) {
                    const content = res.data.data.additional_contents.find(
                        (c) => c.hash === content_hash
                    );
                    setAdditionalContent(content);
                } else if (res.data.data.additional_contents?.length > 0) {
                    // Se não houver content_hash, usar o primeiro conteúdo adicional
                    setAdditionalContent(res.data.data.additional_contents[0]);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => setLoading(false));
    };

    const getCourse = async () => {
        setLoading(true);
        try {
            const { data: res } = await api.get(`/panel/student-courses`);
            const actual_course = res.data.find(
                (course) => course.course_hash === course_hash
            );
            setCourse(actual_course);
            setCoursesLocal(res.data.data);
        } catch (error) {
            console.log(error);
            message.error("Erro ao carregar curso");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (componentMounted) {
            getLesson();
            getCourse();
        }
        return () => {
            componentMounted = false;
        };
    }, [lesson_hash, content_hash]);

    const navigateToLesson = (url) => {
        navigate(url);
    };

    const getContentUrl = (content) => {
        if (!content) return null;
        if (content.link) return content.link;
        if (content.path) return `${api_url}/upload/${content.path}`;
        return null;
    };

    const getExtension = (url) => {
        if (!url) return "";
        const clean = url.split("?")[0];
        const parts = clean.split(".");
        return parts.length > 1 ? parts.pop().toLowerCase() : "";
    };

    const handleAddNote = async () => {
        setLoading(true);
        await api
            .post(
                `/panel/student-courses/${course_hash}/modules/${module_hash}/lessons/${lesson_hash}/notes`,
                {
                    note: textareaValue,
                }
            )
            .then((res) => {
                console.log(res.data.data);
                setLesson(res.data.data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => setLoading(false));
    };

    const [videoHeight, setVideoHeight] = useState(0);
    const [additionalContent, setAdditionalContent] = useState(null);
    const [textContent, setTextContent] = useState(null);
    const [textLoading, setTextLoading] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const sizes = {
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                "2xl": 1400,
                xxl: 1600,
            };

            switch (true) {
                case window.innerWidth < sizes.sm:
                    setVideoHeight(170);
                    break;
                case window.innerWidth < sizes.md:
                    setVideoHeight(300);
                    break;
                case window.innerWidth < sizes.lg:
                    setVideoHeight(400);
                    break;
                case window.innerWidth < sizes.xl:
                    setVideoHeight(500);
                    break;
                case window.innerWidth < sizes["2xl"]:
                    setVideoHeight(500);
                    break;
                case window.innerWidth < sizes.xxl:
                    setVideoHeight(500);
                    break;
                default:
                    setVideoHeight(660);
                    break;
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const actual_module = course?.course_modules?.find(
        (module) => module.hash === module_hash
    );

    const types = {
        0: "Outros",
        1: "Youtube",
        2: "Vimeo",
        3: "Vídeo",
        4: "Webinar",
        5: "Aúdio",
        6: "Ebook",
        7: "Arquivo",
        8: "Texto",
        9: "Imagem",
        10: "PowerPoint",
        11: "Link",
    };

    const iconsPerType = {
        5: <FaFileAudio size={20} />,
        7: <FaFilePowerpoint size={20} />,
        8: <FaBookOpen size={20} />,
        9: <FaImage size={20} />,
        10: <FaRegFilePowerpoint size={20} />,
        11: <FaLink size={20} />,
    };

    const isVideo = [0, 1, 2, 3, 4].includes(additionalContent?.type);
    const [annotations, setAnnotations] = useState([]);
    const [actualAnnotation, setActualAnnotation] = useState(null);

    const getAnnotations = async () => {
        try {
            const { data } = await api.get(`/panel/lesson-notes`);
            setAnnotations(data?.data);
            setProfileLocal({
                ...getProfileLocal(),
                annotations: data?.meta?.total ?? 0,
            });
        } catch (error) {
            console.log(error);
            error?.message && message.error(error?.message);
        }
    };

    useEffect(() => {
        getAnnotations();
    }, []);

    // Fetch text content when additionalContent is type 8 (Texto)
    useEffect(() => {
        let cancelled = false;
        const fetchText = async () => {
            if (additionalContent?.type !== 8) {
                setTextContent(null);
                return;
            }

            const url = additionalContent.link
                ? additionalContent.link
                : additionalContent.path
                ? `${api_url}/upload/${additionalContent.path}`
                : null;

            if (!url) {
                setTextContent(additionalContent?.description || null);
                return;
            }

            setTextLoading(true);
            try {
                const res = await fetch(url);
                const txt = await res.text();
                if (!cancelled) setTextContent(txt);
            } catch (err) {
                if (!cancelled) {
                    setTextContent(additionalContent?.description || null);
                    err?.message && message.error(err.message);
                }
            } finally {
                if (!cancelled) setTextLoading(false);
            }
        };

        fetchText();

        return () => {
            cancelled = true;
        };
    }, [additionalContent]);
    
    return (
        <main style={{ padding: "0 10px" }}>
            {/* media (video, audio, text, image, presentation) moved inside lesson Card below */}

            {lesson_hash && (
                <Card
                    style={{
                        marginBottom: 20,
                        padding: 20,
                    }}
                >
                    {/* media will be rendered below the header */}

                    <Row
                        style={{ padding: "20px", position: "relative" }}
                        justify="space-between"
                        gutter={[16, 16]}
                    >
                        <Col>
                            <Typography>
                                {getProfileLocal()?.actual_course?.course_name}
                            </Typography>
                            <Typography
                                style={{ fontWeight: 700, fontSize: "1.5rem" }}
                            >
                                {lesson?.module?.name}
                            </Typography>
                            <Typography>{additionalContent?.name}</Typography>
                        </Col>
                        <Col>
                            {lesson_hash && (
                                <Button
                                    onClick={handleShowModal}
                                    icon={<AiOutlineFileText size={20} />}
                                ></Button>
                            )}
                            <Modal
                                open={showModal}
                                title="Minhas anotações"
                                onCancel={handleCloseModal}
                                footer={[
                                    <Button
                                        key="cancel"
                                        onClick={handleCloseModal}
                                    >
                                        Fechar
                                    </Button>,
                                    <Button
                                        key="submit"
                                        type="primary"
                                        onClick={async () => {
                                            if (!textareaValue)
                                                return message.error(
                                                    "Você precisa adicionar uma anotação"
                                                );

                                            if (actualAnnotation) {
                                                try {
                                                    const { res } =
                                                        await api.put(
                                                            `/panel/lesson-notes/${actualAnnotation.id}`,
                                                            {
                                                                notes: textareaValue,
                                                            }
                                                        );

                                                    setAnnotations((prev) =>
                                                        prev.map((item) =>
                                                            item.id ===
                                                            actualAnnotation.id
                                                                ? {
                                                                      ...item,
                                                                      notes: textareaValue,
                                                                  }
                                                                : item
                                                        )
                                                    );

                                                    message.success(
                                                        "Anotação editada com sucesso"
                                                    );
                                                } catch (error) {
                                                    error?.message &&
                                                        message.error(
                                                            error.message
                                                        );
                                                }

                                                return;
                                            }

                                            try {
                                                const { data: res } =
                                                    await api.post(
                                                        "/panel/lesson-notes",
                                                        {
                                                            lesson_id:
                                                                lesson.id,
                                                            notes: textareaValue,
                                                        }
                                                    );

                                                message.success(
                                                    "Anotação adicionada com sucesso"
                                                );
                                                setAnnotations((prev) => [
                                                    ...prev,
                                                    res.data,
                                                ]);
                                            } catch (error) {
                                                error?.message &&
                                                    message.error(
                                                        error.message
                                                    );
                                            }
                                        }}
                                    >
                                        {!actualAnnotation
                                            ? "Adicionar"
                                            : "Editar"}
                                    </Button>,
                                ]}
                            >
                                <Typography>Suas anotações</Typography>

                                <List
                                    itemLayout="horizontal"
                                    dataSource={annotations}
                                    style={{
                                        maxHeight: 200,
                                        overflowY: "auto",
                                    }}
                                    renderItem={(item) => (
                                        <List.Item
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor:
                                                    actualAnnotation?.id ===
                                                    item.id
                                                        ? "#f5f5f5"
                                                        : "transparent",
                                            }}
                                        >
                                            <List.Item.Meta
                                                onClick={() => {
                                                    setTextareaValue(
                                                        item.notes
                                                    );
                                                    setActualAnnotation(null);
                                                }}
                                                title={
                                                    item.notes.length > 30
                                                        ? `${item.notes.substring(
                                                              0,
                                                              15
                                                          )}...`
                                                        : item.notes
                                                }
                                            />

                                            <Space>
                                                <Button
                                                    onClick={() => {
                                                        if (
                                                            actualAnnotation?.id ===
                                                            item.id
                                                        )
                                                            return setActualAnnotation(
                                                                null
                                                            );

                                                        setActualAnnotation(
                                                            item
                                                        );
                                                        setTextareaValue(
                                                            item.notes
                                                        );
                                                    }}
                                                    icon={
                                                        <AiOutlineEdit
                                                            size={20}
                                                        />
                                                    }
                                                ></Button>

                                                <Button
                                                    onClick={async () => {
                                                        try {
                                                            const {
                                                                data: res,
                                                            } =
                                                                await api.delete(
                                                                    `/panel/lesson-notes/${item.id}`
                                                                );
                                                            message.success(
                                                                "Anotação excluída com sucesso"
                                                            );

                                                            setAnnotations(
                                                                (prev) =>
                                                                    prev.filter(
                                                                        (
                                                                            prevItem
                                                                        ) =>
                                                                            prevItem.id !==
                                                                            item.id
                                                                    )
                                                            );
                                                        } catch (error) {
                                                            error?.message &&
                                                                message.error(
                                                                    error.message
                                                                );
                                                        }
                                                    }}
                                                    icon={
                                                        <AiOutlineDelete
                                                            size={20}
                                                        />
                                                    }
                                                    style={{ color: "red" }}
                                                ></Button>
                                            </Space>
                                        </List.Item>
                                    )}
                                />

                                <TextArea
                                    value={textareaValue}
                                    onChange={handleTextareaChange}
                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                    style={{ marginTop: 20 }}
                                />
                            </Modal>
                        </Col>

                        {lesson?.main_content_text?.length > 0 && (
                            <Col span={24}>
                                <Title level={4}>Conteúdo</Title>

                                <Typography>
                                    {lesson?.main_content_text}
                                </Typography>
                            </Col>
                        )}

                        <Col span={24}>
                            {lesson.description && (
                                <Typography
                                    onClick={handleShowDescription}
                                    style={{
                                        color: "#dc6f10",
                                        fontSize: "1rem",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    Sobre o curso{" "}
                                    {showDescription ? (
                                        <UpOutlined />
                                    ) : (
                                        <DownOutlined />
                                    )}
                                </Typography>
                            )}
                            {lesson.description && showDescription && (
                                <div
                                    style={{
                                        padding: "20px",
                                        border: "1px solid #dc6f10",
                                        borderRadius: "5px",
                                        maxHeight: "600px",
                                        overflow: "auto",
                                    }}
                                >
                                    <Typography
                                        dangerouslySetInnerHTML={{
                                            __html: lesson.description,
                                        }}
                                    />
                                </div>
                            )}

                            {!!lesson.main_content_path &&
                                lesson?.main_content_type === 5 && (
                                    <ReactPlayer
                                        url={`${api_url}/upload/${lesson.main_content_path}`}
                                        style={{
                                            marginBottom: "20px",
                                        }}
                                        height={"50px"}
                                        width={"100%"}
                                        controls
                                    />
                                )}
                        </Col>
                    </Row>

                    {/* media (video, audio, text, image, presentation) shown after header texts */}
                    {isVideo && (additionalContent?.link || additionalContent?.path) &&
                        (loading ? (
                            <Spin
                                size="large"
                                style={{
                                    width: "100%",
                                    height: videoHeight,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "20px 0",
                                }}
                            />
                        ) : (
                            <ReactPlayer
                                url={
                                    additionalContent.link
                                        ? additionalContent.link
                                        : `${api_url}/upload/${additionalContent.path}`
                                }
                                width={"100%"}
                                height={videoHeight}
                                style={{
                                    marginBottom: "20px",
                                }}
                                controls
                            />
                        ))}

                    {additionalContent?.type === 5 && (additionalContent?.link || additionalContent?.path) && (
                        <div style={{ marginBottom: 20, position: "relative", zIndex: 0, overflow: "hidden" }}>
                            <ReactPlayer
                                url={
                                    additionalContent.link
                                        ? additionalContent.link
                                        : `${api_url}/upload/${additionalContent.path}`
                                }
                                width={"100%"}
                                height={50}
                                style={{ marginBottom: "20px", position: "relative", zIndex: 1 }}
                                controls
                            />
                        </div>
                    )}

                    {additionalContent?.type === 8 && (
                        <Card style={{ marginBottom: 20, position: "relative", zIndex: 0, overflow: "auto" }}>
                            {textLoading ? (
                                <div style={{ height: videoHeight, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Spin />
                                </div>
                            ) : (
                                <div style={{ whiteSpace: "pre-wrap", position: "relative", zIndex: 1 }}>
                                    {textContent ? (
                                        /</.test(textContent) ? (
                                            <div dangerouslySetInnerHTML={{ __html: textContent }} />
                                        ) : (
                                            textContent
                                        )
                                    ) : (
                                        additionalContent?.text || "Conteúdo de texto não disponível."
                                    )}
                                </div>
                            )}
                        </Card>
                    )}

                    {additionalContent?.type === 11 && additionalContent?.link && (
                        <Card style={{ marginBottom: 20 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography>{additionalContent.name || 'Link'}</Typography>
                                <Button type="primary" onClick={() => window.open(additionalContent.link, '_blank')}>
                                    Abrir link
                                </Button>
                            </div>
                        </Card>
                    )}

                    {!!additionalContent?.path && additionalContent?.type === 9 && (
                        <Card
                            style={{
                                marginBottom: "20px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                                zIndex: 0,
                                overflow: "hidden",
                            }}
                        >
                            <Image
                                src={`${api_url}/upload/${additionalContent?.path}`}
                                width={"100%"}
                                height={videoHeight}
                            />
                        </Card>
                    )}

                    {/* Arquivo (type 7) - show inline if browser can render, otherwise show download button */}
                    {additionalContent?.type === 7 && (additionalContent?.link || additionalContent?.path) && (() => {
                        const url = getContentUrl(additionalContent);
                        const ext = getExtension(url);
                        const imageExt = ["jpg","jpeg","png","gif","svg","webp"];
                        const videoExt = ["mp4","webm","ogg"];
                        const audioExt = ["mp3","wav","ogg"];
                        const inlineExt = ["pdf","txt","html","htm"];

                        if (!url) return (
                            <div style={{ marginBottom: 20 }}>
                                <Button onClick={() => message.error('Arquivo não disponível')}>Baixar</Button>
                            </div>
                        );

                        if (imageExt.includes(ext)) {
                            return (
                                <Card style={{ marginBottom: 20 }}>
                                    <Image src={url} width={'100%'} />
                                </Card>
                            );
                        }

                        if (videoExt.includes(ext)) {
                            return (
                                <ReactPlayer url={url} width={'100%'} height={videoHeight} controls style={{ marginBottom: 20 }} />
                            );
                        }

                        if (audioExt.includes(ext)) {
                            return (
                                <div style={{ marginBottom: 20 }}>
                                    <audio controls src={url} style={{ width: '100%' }} />
                                </div>
                            );
                        }

                        if (inlineExt.includes(ext)) {
                            return (
                                <Card style={{ marginBottom: 20 }}>
                                    <iframe src={url} title="arquivo" style={{ width: '100%', height: videoHeight, border: 0 }} frameBorder="0" />
                                </Card>
                            );
                        }

                        // fallback: show download button (start download in same tab)
                        return (
                            <div style={{ marginBottom: 20 }}>
                                <Button
                                    type="primary"
                                    icon={<FaPaperclip />}
                                    onClick={() => {
                                        try {
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.setAttribute('download', '');
                                            a.target = '_self';
                                            document.body.appendChild(a);
                                            a.click();
                                            a.remove();
                                        } catch (err) {
                                            window.location.href = url;
                                        }
                                    }}
                                >
                                    Baixar arquivo
                                </Button>
                            </div>
                        );
                    })()}

                    {!!additionalContent?.link && additionalContent?.type === 10 && (
                        <Card
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: 16,
                                marginBottom: 20,
                                position: "relative",
                                zIndex: 0,
                                overflow: "hidden",
                            }}
                        >
                            <iframe 
                                id="presentation-iframe"
                                src={additionalContent.link.replace("/pub?", "/pubembed?")} 
                                frameBorder="0" 
                                allowFullScreen={true} 
                                mozallowfullscreen="true" 
                                webkitallowfullscreen="true" 
                            />
                        </Card>
                    )}

                    <Row
                        style={{ padding: "0 0 20px 20px" }}
                        justify="space-between"
                        align="bottom"
                    >
                    </Row>
                </Card>
            )}
            <Row justify="space-between">
                <Col span={24}>
                    <Card
                        title={`Módulo: ${actual_module?.name ?? ""}`}
                        style={{
                            padding: "20px",
                            marginBottom: "20px",
                            maxHeight: "600px",
                            overflow: "auto",
                        }}
                    >
                        {actual_module?.lessons?.map((lesson) => (
                            <Collapse
                                key={`${lesson.hash}`}
                                bordered={false}
                                onChange={handleLessonKey}
                                activeKey={openLessonKey}
                                expandIconPosition="right"
                                expandIcon={({ isActive }) => (
                                    <RightOutlined rotate={isActive ? 90 : 0} />
                                )}
                                defaultActiveKey={[`${lesson_hash}`]}
                            >
                                <Panel
                                    header={
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {lesson.name}
                                            </span>
                                        </div>
                                    }
                                    key={`${lesson.hash}`}
                                >
                                    <Row
                                        gutter={[16, 16]}
                                        style={{
                                            maxHeight: "600px",
                                            overflow: "auto",
                                        }}
                                    >
                                        {lesson?.additional_contents?.map(
                                            (content) => (
                                                <Col span={24}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "space-between",
                                                            padding: "10px 0",
                                                            borderBottom:
                                                                "1px solid #E8E8E8",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                gap: "10px",
                                                            }}
                                                        >
                                                            {content.type &&
                                                                (iconsPerType[
                                                                    content.type
                                                                ] ?? (
                                                                    <FaVideo
                                                                        size={
                                                                            20
                                                                        }
                                                                    />
                                                                ))}

                                                            <Typography>
                                                                {content.name}
                                                            </Typography>
                                                        </div>

                                                        <div>
                                                            <Button
                                                                type="primary"
                                                                onClick={() => {
                                                                    if (content.type === 11 && content.link) {
                                                                        // open external links in a new tab
                                                                        return window.open(content.link, '_blank');
                                                                    }

                                                                    // navigate to lesson view for all other content types
                                                                    navigateToLesson(
                                                                        `/mycourses/${course_hash}/modules/${actual_module.hash}/lessons/${lesson.hash}/${content.hash}`
                                                                    );
                                                                }}
                                                            >
                                                                {[
                                                                    0, 1, 2, 3,
                                                                    4,
                                                                ].includes(
                                                                    content.type
                                                                )
                                                                    ? "Assistir"
                                                                    : "Visualizar"}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )
                                        )}
                                    </Row>
                                </Panel>
                            </Collapse>
                        ))}
                    </Card>
                </Col>
            </Row>
            <Row>
                <Link to={`/mycourses/${course?.enrollment_hash}`}>
                    <Button type="primary" size="large">
                        Voltar ao curso
                    </Button>
                </Link>
            </Row>
        </main>
    );
}
